import { Flex, Typography } from 'antd';
import { formDatesRangeString } from 'shared/utils/wh-tasks/form-dates-range-string';
import type { IWhTaskDatesProps } from './types';
import styles from './wh-task-dates.module.scss';

export const WhTaskDates = (props: IWhTaskDatesProps) => {
  const { type, arrivalDate, departureDate, realArrivalDate, realDepartureDate } = props;

  const isReloading = type === 'reloading';

  return (
    <Flex vertical>
      <Typography.Text>{formDatesRangeString(arrivalDate, departureDate, isReloading)}</Typography.Text>
      {realArrivalDate && (
        <Typography.Text className={styles.secondary}>
          {formDatesRangeString(realArrivalDate, realDepartureDate, isReloading)}
        </Typography.Text>
      )}
    </Flex>
  );
};
